import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private timeout: any;
  private inactivityTime: number = 30000; // 30 segundos
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setInactivityTime(inactivityTime){
    this.inactivityTime = inactivityTime;
  }

  initializeInactivityDetection(onInactive: () => void) {
    // Escucha eventos de interacción del usuario
    const resetTimer = () => this.resetInactivityTimer(onInactive);

    this.renderer.listen('document', 'click', resetTimer);
    this.renderer.listen('document', 'touchstart', resetTimer);

    // Inicializa el temporizador la primera vez
    this.resetInactivityTimer(onInactive);
  }

  private resetInactivityTimer(onInactive: () => void) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      onInactive();
    }, this.inactivityTime);
  }

  stopInactivityDetection() {
    clearTimeout(this.timeout);
  }
}